/*
  CFG - Father's Day Sale: Cart $150 progress nudge
  Mirrors cfg_free-shipping-bar.js. Shows how much more the customer needs to
  add to reach the $150 minimum for the 20% off DAD code.
*/
(function () {
  'use strict';

  var selectors = {
    bar: '#FDSaleBar',
    message: '.fd-sale-bar__message',
    progress: '.fd-sale-bar__progress',
    drawerSubtotal: '[data-subtotal]'
  };

  function init() {
    var bar = document.querySelector(selectors.bar);
    if (!bar) return;

    var threshold = parseInt(bar.dataset.threshold, 10);
    if (isNaN(threshold)) return;

    updateBar(bar, threshold);

    // 1. Ajax product added (fired from theme.js)
    document.addEventListener('ajaxProduct:added', function () {
      setTimeout(function () { updateBar(bar, threshold); }, 500);
    });

    // 2. Observe subtotal changes (qty updates within the drawer)
    var subtotalEl = document.querySelector(selectors.drawerSubtotal);
    if (subtotalEl) {
      var observer = new MutationObserver(function () {
        updateBar(bar, threshold);
      });
      observer.observe(subtotalEl, { childList: true, subtree: true, characterData: true });
    }

    // 3. Drawer open
    document.addEventListener('cart:open', function () {
      updateBar(bar, threshold);
    });
  }

  function updateBar(bar, threshold) {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var total = cart.total_price;
        var progress = Math.min((total / threshold) * 100, 100);
        var remaining = threshold - total;

        var messageEl = bar.querySelector(selectors.message);
        var progressEl = bar.querySelector(selectors.progress);

        if (progressEl) {
          progressEl.style.width = progress + '%';
        }

        if (messageEl) {
          if (remaining > 0) {
            var remainingFormatted = (window.theme && theme.Currency)
              ? theme.Currency.formatMoney(remaining, theme.settings.moneyFormat)
              : '$' + (remaining / 100).toFixed(2);
            remainingFormatted = remainingFormatted.replace('.00', '');
            messageEl.innerHTML = 'Add ' + remainingFormatted +
              ' more to unlock <strong>20% off</strong> with code <strong>DAD</strong>';
          } else {
            messageEl.innerHTML = "You've unlocked <strong>20% off</strong>! Use code <strong>DAD</strong> at checkout.";
          }
        }
      })
      .catch(function (error) { console.error('Error fetching cart:', error); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
